import React from 'react';

import BaseUsasClubContextProvider from '@usas/ui-web/state/clubBase/BaseUsasClubContextProvider';
import BaseUsasClubFiltersContextProvider from '@usas/ui-web/state/clubBase/BaseUsasClubFiltersContextProvider';
import PersonOrgRoleContextProvider from '@usas/ui-web/state/personOrgRole/PersonOrgRoleContextProvider';
import SearchClubContextProvider from '@usas/ui-web/state/searchClub/SearchClubContextProvider';
import SelectOrgUnitContextProvider from '@usas/ui-web/state/selectOrgUnit/SelectOrgUnitContextProvider';
import MeetResultsStatusContextProvider from '@usas/ui-web/state/meet/meetResultsUploadStatus/MeetResultsStatusContextProvider';

import ClubRegistrationNewContextProvider from '../../state/clubRegistrationNew/ClubRegistrationNewContextProvider';

const ClubContextProviders = ({ children }) => {
  return (
    <SelectOrgUnitContextProvider>
      <MeetResultsStatusContextProvider>
        <PersonOrgRoleContextProvider>
          <BaseUsasClubContextProvider>
            <BaseUsasClubFiltersContextProvider>
              <SearchClubContextProvider>
                <ClubRegistrationNewContextProvider>
                  {children}
                </ClubRegistrationNewContextProvider>
              </SearchClubContextProvider>
            </BaseUsasClubFiltersContextProvider>
          </BaseUsasClubContextProvider>
        </PersonOrgRoleContextProvider>
      </MeetResultsStatusContextProvider>
    </SelectOrgUnitContextProvider>
  );
};

export default ClubContextProviders;